var map = {
	"./barredores.svg": 2912,
	"./bascula.svg": 3227,
	"./calendario.svg": 8492,
	"./choferes.svg": 1177,
	"./clientes.svg": 9350,
	"./desechos.svg": 4936,
	"./flota.svg": 5481,
	"./home.svg": 5127,
	"./identificadores.svg": 8747,
	"./monitoreo.svg": 7269,
	"./pesajes.svg": 3772,
	"./planes.svg": 6280,
	"./rastreadores.svg": 8521,
	"./reportes.svg": 3146,
	"./servicios.svg": 2765,
	"./supervision.svg": 260,
	"./usuarios.svg": 8702
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 8017;